import { render, staticRenderFns } from "./ArticleCategoryPicker.vue?vue&type=template&id=1ec28b70&scoped=true&"
import script from "./ArticleCategoryPicker.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoryPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec28b70",
  null
  
)

export default component.exports